import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  Alert,
  SafeAreaView,
  Platform,
} from "react-native";

import { Button } from "../../../../button";
import { sendMoneyService } from "../../../../services/sendmoney.service";
import { useApiWithLoading } from "../../../../hooks/useApiWithLoading";
import { useWorkflowNavigation } from "../hooks/useWorkflowNavigation";
import { useStepAction } from "../hooks/useStepAction";
import { sendWorkflowManager } from "../sendWorkflow/builder/workflowManager";
import { useJourneyStore } from "../store/sendmoneyJourneyStore";
import FloatingTextInputComponent from "../../common/FloatingTextInputComponent";
import { ComponentStyles } from "../../../../constants/componentStyles";
import Colors from "../../../../constants/colors";
/**
 * Purpose:
 * Collect customer phone number.
 *
 * Why:
 * First step of Send Money workflow.
 *
 * Responsibilities:
 * - Capture phone number
 * - Trigger Consumer Lookup
 *
 * Does NOT:
 * - Build workflow
 * - Determine next step
 */
export function PhoneScreen() {
  const updateJourneyData = useJourneyStore((state) => state.updateJourneyData);
  const [phoneNumber, setPhoneNumber] = useState("");
  const { goNext } = useWorkflowNavigation();
  const { executeWithLoading } = useApiWithLoading();
  const handleNext = async () => {
    if (!phoneNumber.trim()) {
      return;
    }
    const response = await executeWithLoading(
      () => sendMoneyService.lookupConsumer(phoneNumber),
      "Processing..."
    );
    updateJourneyData({ phoneNumber: phoneNumber });
    sendWorkflowManager.updateContext({
    //  isExistingCustomer: response.profiles.length > 0,
    isExistingCustomer: false, // for now lets hardcode it to false as we are only dealing with transaction not with profile. 
    });
    goNext();
  };

  useStepAction(handleNext);

  const Wrapper = Platform.OS === "web" ? View : SafeAreaView;
  return (
    <Wrapper style={styles.container} testID="phone-screen">
      <Text style={styles.title}>Enter your phone number</Text>
      <Text style={styles.subtitle}>Enter the customer's phone number to search MAPI profiles.</Text>
      <FloatingTextInputComponent
        testID="phone-input"
        label="Enter your phone number"
        value={(phoneNumber)}
        onChangeText={(text) => setPhoneNumber(text)}
        keyboardType="number-pad"
        errorText={null}
        onClearError={() => setPhoneNumber("")}
        isAutoFocus={true}
      />
    </Wrapper>
  );
}

// why named export ? instead of default export ? because Imports are explicit.
// export function PhoneScreen() ==> named export
// import this way => import { PhoneScreen } from "../pages/PhoneScreen";

// after this, lets create router.

// Phone Screen => ConsumerLookup => Updated WorkFlow Contenxt => workflow rebuild => navigat next

//IMP
// whats happeing internally:
// user enters number, clicks next , service is called,
// workflowContextStore updates "isExistingxustomer" to true, useWorkflowInitialization sees:
// Workflow Context changed
// and rebuilds workflow:
// new workflow: Phone, Pin, Country, State, Amount, Review

// useWorkflowNavigation sees: Next Step is Pin
// React Router navigates to Pin Screen

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    paddingHorizontal: 24,
  },
  scrollContainer: {
    paddingHorizontal: 24,
    paddingBottom: 40,
    alignItems: "stretch",
    justifyContent: "flex-start"
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: '500', 
    color: Colors.titleTextColor,
    lineHeight: 34,
    marginBottom: 8
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 24,
    color: Colors.subTitleColor,
    marginBottom: 24
  },
  phoneInputContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 20,
  },
  countryCodeSelector: {
    height: 56,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colors.textInputBackground,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 6,
    marginRight: 8,
  },
  countryText: {
    fontSize: 14,
    fontWeight: "600",
    color: "#111827",
    marginRight: 4,
  },
  plusText: {
    fontSize: 16,
    fontFamily: 'Rubik',
    fontWeight: "400",
    lineHeight: 24,
    color: Colors.titleTextColor,
    marginLeft: 8
  },
  textInput: {
    width: 295,
    height: 56,
    backgroundColor: Colors.textInputBackground,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: Platform.OS === "ios" ? 12 : 6,
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 24,
    color: "#111827",
  },
  flagContainer: {
    height: 24,
    width: 24,
    borderRadius: 50,
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
  },
});
